import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { apiUrl } from '../app.config';
import { DataService } from './data.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import { EnvironmentSetting } from '../models/plan/environmentSetting';
@Injectable()
export class UsedcarDetailService {
  static headers = new Headers({ 'Content-Type': 'application/json' });

  constructor(
    private _http: Http,
    private _data: DataService,
    private router: Router,
  ) { }

  getDetail(id: string, monthlyLeaseKbn: string, dataEnvironmentSetting: EnvironmentSetting) {
    const path = `${apiUrl}/btob/stocks-v2/${id}`;
    let q = '';
    q = '?monthlyLease=' + monthlyLeaseKbn;
    if (dataEnvironmentSetting) {
      q += '&additionalPrice=' + dataEnvironmentSetting.carPriceAdjustmentForKei
       + ',' + dataEnvironmentSetting.carPriceAdjustmentForFutsuu + ','
       + dataEnvironmentSetting.carPriceAdjustmentForImport;
    }
    const headers = new Headers();
    headers.set('auth', this._data.token);
    return this._http
      .get(path + q, {
        headers: headers
      })
      .map(data => data.json())
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    if (error.status === 401) {
      this.deleteToken();
    } else {
      return Observable.throw(errMsg);
    }
  }

  private handleError2(error: any) {
    // console.log('error', error);
    return Observable.throw(error.json());
  }

  deleteToken() {
    const headerParams = UsedcarDetailService.headers;
    headerParams.set('auth', this._data.token);
    if (this._data.token !== null) {
      this.clearDataAndNavigateToLogin();
      return this._http
        .delete(`${apiUrl}/auth/token`, { headers: UsedcarDetailService.headers })
        .subscribe(() => { });
    }
  }

  clearDataAndNavigateToLogin() {
    this._data.clearData();
    this.router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/usedcar-detail.service.ts